import { BoxProps } from '@chakra-ui/react';
import { commonConfig } from '../../core/config';

const types = {
  image: {
    base: 'images',
    prefix: 'image-',
  },
  file: {
    base: 'files',
    prefix: 'file-',
  },
};

// https://www.sanity.io/docs/image-urls
type Fit = 'clip' | 'crop' | 'fill' | 'fillmax' | 'max' | 'scale' | 'min';
export type ImageSettings = (
  | `w=${number}`
  | `h=${number}`
  | `blur=${number}`
  | `crop=center`
  | `crop=${string}`
  | `fit=${Fit}`
)[];
const getUrl =
  <TProps extends string[] | never>(type: keyof typeof types) =>
  (ref: string | undefined, props?: TProps): string | undefined =>
    ref
      ? `${commonConfig.sanity.cdnUrl}/${types[type].base}/${commonConfig.sanity.appId}/production/${ref
          .replace(types[type].prefix, '')
          .replace(/-([^-]*)$/, '.$1')}?${(props || []).join('&')}`
      : ref;

export const getFileUrl = getUrl<never>('file');
export const getImageUrl = getUrl<ImageSettings>('image');

const whiteTextMap: Record<string, boolean> = {
  'gray.800': true,
  'gray.900': true,
  'red.800': true,
};
export const getTextColor = (bg = ''): string | undefined =>
  whiteTextMap[bg] ? 'white' : undefined;

export const secondaryTextColor = (bgColor?: BoxProps['bgColor']) =>
  bgColor === 'red.800' ? 'orange.200' : 'gray.500';
